import { PlanStep } from '@core/models/plan.model';
import { FlowchartMode } from '@flowchart';
import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WithProp } from '@utils';

import { planFK, planLinksAdapter, PlanState, planStepsAdapter } from './plan.reducer';


const selectFeature = createFeatureSelector<PlanState>(planFK);

const plan = createSelector(selectFeature, (state => state.plan));

const selectSteps = createSelector(selectFeature, (state => state.steps));
const stepsSelectors = planStepsAdapter.getSelectors(selectSteps);
const steps = {
  ...stepsSelectors,
  selectById: createSelector(
    stepsSelectors.selectEntities,
    (entities: Dictionary<PlanStep>, props: { id: number }) => entities[props.id] as WithProp<PlanStep, 'id'>
  )
};

const selectLinks = createSelector(selectFeature, (state => state.links));
const links = planLinksAdapter.getSelectors(selectLinks);

const flowchartMode = createSelector(plan,
  p => 'edit' as FlowchartMode
);

export const planSelectors = {
  plan,
  steps,
  links,
  flowchartMode,
};
